/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button, DropDown, Input } from "../../../components";
import {
  CourtBookingDataType,
  SelectedSlotType,
} from "../../../utilities/types";
import { CalendarModal } from "../../../sub-modules/CalendarModal/CalendarModal";
import * as yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { GetFilterdCourt } from "../../../utilities/api/courts";
import { GetSportsForFacility } from "../../../utilities/api/sports/indext";
import { CourtBookingAmount } from "../../../utilities/api/courtBooking";
import { ToastContainer, toast } from "react-toastify";
import { format } from "date-fns";
import { images } from "../../../config/images";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.courts;

const CourtSearch = (props: any) => {
  const {
    courtBookingData,
    setCourtBookingData,
    name,
    setCurrentStep,
  } = props;
  const [show, setShow] = useState(false);
  const [courtList, setCourtList] = useState<any>([]);
  const [sportList, setSportList] = useState([]);
  const [ruleList, setRuleList] = useState({}) as any;

  const currentDate = format(new Date(), "dd-MM-yyyy");
  const [maxPreBookingDay, setMaxPreBookingDay] = useState(0);

  const [schema, setSchema] = useState({
    sportId: yup
      .number()
      .typeError(getMessage.sport_required)
      .required(getMessage.sport_required),
    courtId: yup.number().required(getMessage.court_required),
  });

  useEffect(() => {
    if (name !== "OFFICE_ADMIN") {
      setSchema(
        Object.assign(schema, {
          bookingType: yup.string().required(getMessage.bookingType_required),
        })
      );
    }
  }, [name]);

  const courtSearchSchema = yup.object().shape(schema);

  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useForm<CourtBookingDataType>({
    resolver: yupResolver(courtSearchSchema),
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleContinue: SubmitHandler<any> = async (data) => {
    let payload = {
      facilityId: Number(courtBookingData.facilityId),
      sportId: Number(courtBookingData.sportId),

      courtId: Number(courtBookingData.courtId),

      selectedSlots: courtBookingData.selectedSlots?.map((slot: any) => ({
        fromTime: slot.fromTime,
        toTime: slot.toTime,
        bookingDate: slot.bookingDate,
      })),
      isIgstTax: "false",
      discount: "",
    };

    const result = await CourtBookingAmount(payload);
    if (result.status == 200) {

      setCurrentStep((_oldVal: number) => {
        if (_oldVal < 1) {
          return ++_oldVal;
        } else {
          return _oldVal;
        }
      });
      setCourtBookingData({
        ...courtBookingData,
        ...data,
        amount: result.data.data,
      });
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetCourt = async () => {
    const result = await GetFilterdCourt(
      courtBookingData.facilityId,
      courtBookingData.sportId,
      "true"
    );
    if (result.statusCode == 200) {
      setCourtList(result.data.rows);
      if (courtBookingData.courtId.toString() != "") {
        let maxDay = result.data.rows.filter(
          (item: any) => item.id == courtBookingData.courtId.toString()
        )[0];
        setMaxPreBookingDay(maxDay?.preBookingMaxDays);
      }
    }
  };

  const GetSport = async () => {
    const result = await GetSportsForFacility(courtBookingData.facilityId);
    if (result.statusCode == 200) {
      setSportList(result.data.rows);
      if (courtBookingData.sportId != "") {
        setRuleList(
          result.data.rows.filter(
            (item: any) => item.id == courtBookingData.sportId
          )[0]
        );
      }
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetSport();
  }, [courtBookingData.facilityId]);

  useEffect(() => {
    GetCourt();
  }, [courtBookingData.facilityId, courtBookingData.sportId]);

  useEffect(() => {

    reset(courtBookingData);
  }, [courtBookingData]);

  const handleDeleteSlot = (index: number) => {
    const result = courtBookingData.selectedSlots?.filter(
      (_: any, ind: number) => ind !== index
    );

    setCourtBookingData({ ...courtBookingData, selectedSlots: [...result] });
  };

  const handleSportId = (e: any) => {
    setCourtBookingData({
      ...courtBookingData,
      sportId: e.target.value,
      courtId: "",
      selectedSlots: [],
    });
    setRuleList(sportList.filter((item: any) => item.id == e.target.value)[0]);
  };

  const handleCourtId = (e: any) => {
    setCourtBookingData({
      ...courtBookingData,
      courtId: e.target.value,
      selectedSlots: [],
    });
    let maxDay = courtList.filter((item: any) => item.id == e.target.value)[0];
    setMaxPreBookingDay(maxDay?.preBookingMaxDays);
  };

  return (
    <>
      <Container fluid className="g-0">
        <form onSubmit={handleSubmit(handleContinue)}>
          <Card>
            <Card.Body>
              <Card.Title className="text-start">Courts Booking</Card.Title>
              <Row>
                {name !== "OFFICE_ADMIN" && (
                  <Col lg={6}>
                    <div className="mb-3 text-start">
                      <label htmlFor="bookingtype" className="form-label">
                        Booking Type{" "}
                      </label>
                      <DropDown
                        value={courtBookingData.bookingType}
                        className="form-control"
                        id="bookingtype"
                        name="bookingType"
                        register={register}
                        required
                        onChange={(e: any) =>
                          setCourtBookingData({
                            ...courtBookingData,
                            bookingType: e.target.value,
                          })
                        }
                      >
                        <option hidden disabled value="">
                          Select Booking Type
                        </option>
                        <option value={"individual"}>Individual Booking</option>
                        <option value={"corporate"}>Corporate Booking</option>
                      </DropDown>
                      <span className="error-msg">
                        {errors?.bookingType?.message}
                      </span>
                    </div>
                  </Col>
                )}
                <Col lg={name !== "OFFICE_ADMIN" ? 6 : 12}>
                  <div className="mb-3 text-start">
                    <label htmlFor="sportId" className="form-label">
                      Select Sport
                    </label>
                    <DropDown
                      disabled={courtBookingData?.facilityId <= 0}
                      value={courtBookingData.sportId}
                      className="form-control"
                      id="sportId"
                      name="sportId"
                      register={register}
                      required
                      onChange={(e: any) => handleSportId(e)}
                    >
                      <option hidden disabled value="">
                        Select Sport
                      </option>
                      {sportList?.map((item: any) => {
                        return (
                          <option key={item.id + "sport"} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </DropDown>
                    <span className="error-msg">
                      {errors?.sportId?.message}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="courtId" className="form-label">
                      Select Court
                    </label>
                    <DropDown
                      disabled={courtBookingData.sportId <= 0}
                      value={courtBookingData.courtId.toString()}
                      className="form-control"
                      id="courtId"
                      name="courtId"
                      register={register}
                      required
                      onChange={(e: any) => handleCourtId(e)}
                    >
                      <option hidden disabled value="">
                        Select Court
                      </option>
                      {courtList?.map((item: any) => {
                        return (
                          <option
                            key={item.id + "court"}
                            value={item.id.toString()}
                          >
                            {" "}
                            {item.name}{" "}
                          </option>
                        );
                      })}
                    </DropDown>
                    <span className="error-msg">
                      {errors?.courtId?.message}
                    </span>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="text-start">
                    <label htmlFor="selectdate" className="form-label">
                      Select Date
                    </label>
                    <Input
                      disabled={courtBookingData.courtId <= 0}
                      type="text"
                      placeholder="Select Date"
                      id="dateselect"
                      name="dateselect"
                      onClick={handleShow}
                      className="form-control"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <div className="text-start">
                    <label
                      htmlFor="selectendtime"
                      className="form-label d-block"
                    >
                      Selected Slots ({courtBookingData.selectedSlots?.length}){" "}
                      {courtBookingData.selectedSlots.length < 2 && (
                        <span className="badge h-100 me-2 p-2 slot-box text-start text-black">
                          <span className="text-primary">Note</span> : Minimum{" "}
                          <span className="text-primary">2</span> slot's must be
                          selected
                        </span>
                      )}
                    </label>
                    {courtBookingData.selectedSlots?.map(
                      (item: SelectedSlotType, index: number) => {
                        return (
                          <div
                            key={"selected-slots" + index}
                            className="bg-light d-inline-block p-2 slot-box text-start mb-3 me-3 mt-1"
                            style={{ width: "130px" }}
                          >
                            <span className="d-block">
                              {item.bookingDate?.split("-").reverse().join("/")}
                            </span>
                            <span className="text-primary">
                              {item.fromTime} to {item.toTime}
                            </span>
                            <img
                              onClick={() => handleDeleteSlot(index)}
                              src={images.deletesport.default}
                              width="19"
                              alt=""
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Card>
                    <Card.Body className="p-3">
                      <Card.Title className="card-title h5 text-start mb-2">
                        Rules of Booking
                      </Card.Title>
                      <ol className="list-group list-group-flush list-group-numbered text-start">
                        {ruleList?.sportRules?.map((item: any) => {
                          return (
                            <li key={item.id} className="list-group-item">
                              {item.rule.subject}
                            </li>
                          );
                        })}
                      </ol>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col lg={12} className="text-end mt-3">
                  <Button
                    disabled={courtBookingData.selectedSlots.length < 2}
                    type="submit"
                    bname="Continue"
                    name="continue"
                    id="continue"
                    className="btn btn-primary px-4 rounded-1"
                  ></Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </form>
      </Container>
      <CalendarModal
        show={show}
        handleClose={handleClose}
        selectedSlots={courtBookingData}
        setSelectedSlots={setCourtBookingData}
        courtId={courtBookingData.courtId}
        slotDate={currentDate}
        forBooking={"Add_Booking"}
        maxPreBookingDay={maxPreBookingDay}
      />
      <ToastContainer />
    </>
  );
};
export { CourtSearch };
